import useSWR from "swr";
import { toast } from "sonner";
import { fetcher, http, apiError } from "@/lib/api";
import { DataTable, fmtDate } from "@/components/admin/DataTable";

const MODES = { video: "Video Call", phone: "Phone Call", factory: "Office Visit" };

export function MeetingsTab() {
  const { data, mutate } = useSWR("/admin/meetings", fetcher);

  const setStatus = async (id, status) => {
    try {
      await http.patch(`/admin/meetings/${id}`, { status });
      toast.success(`Meeting marked ${status}`);
      mutate();
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  const columns = [
    { label: "Date", key: "date", render: (r) => <span className="whitespace-nowrap font-medium">{r.date} · {r.time}</span>, csv: (r) => `${r.date} ${r.time}` },
    { label: "Client", key: "name", render: (r) => <div><div className="font-medium">{r.name}</div><div className="text-xs text-[#556B57]">{r.company}</div></div> },
    { label: "Contact", key: "email", render: (r) => <div className="text-xs"><a href={`mailto:${r.email}`} className="block underline">{r.email}</a>{r.phone}</div>, csv: (r) => `${r.email} / ${r.phone}` },
    { label: "Mode", key: "mode", render: (r) => MODES[r.mode] || r.mode, csv: (r) => MODES[r.mode] },
    { label: "Topic", key: "topic" },
    { label: "Notes", key: "notes", render: (r) => <span className="text-xs text-[#556B57] line-clamp-3 max-w-[220px] block">{r.notes || "-"}</span> },
    {
      label: "Status", key: "status",
      render: (r) => (
        <select data-testid={`meeting-status-${r.id}`} value={r.status} onChange={(e) => setStatus(r.id, e.target.value)}
          className="h-9 px-3 rounded-full border border-[#D7D4CF] text-xs bg-white focus:outline-none focus:border-[#C9A961]">
          <option value="confirmed">Confirmed</option>
          <option value="completed">Completed</option>
          <option value="cancelled">Cancelled</option>
        </select>
      ),
    },
    { label: "Booked", key: "created_at", render: (r) => <span className="text-xs whitespace-nowrap">{fmtDate(r.created_at)}</span> },
  ];
  return <DataTable rows={data} columns={columns} testid="admin-meetings-table" title="Meetings" filename="fresio-meetings" />;
}
